import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';
import { UserDtoSchema } from '../contracts';

const UpdateUserRequestDtoSchema = z.object({
  id: z.number(),
  fullName: z.string().optional(),
  profileUrl: z.string().optional(),
});

const UpdateUserResponseDtoSchema = UserDtoSchema;

export type UpdateUserRequestDto = z.infer<typeof UpdateUserRequestDtoSchema>;
export type UpdateUserResponseDto = z.infer<typeof UpdateUserResponseDtoSchema>;

export const updateUser = (
  dto: UpdateUserRequestDto,
  config?: AxiosRequestConfig<UpdateUserRequestDto>
) => {
  const { id, ...data } = UpdateUserRequestDtoSchema.parse(dto);
  return api
    .patch(`/users/${id}`, data, config)
    .then(responseContract(UpdateUserResponseDtoSchema));
};
